<template>
<div class="contain" >
      <div class="row m-0 p-0">
      <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12  " style="margin-top:90px;">
         <div class="contact_para" >
                  <h1 class="contact_text">Contact</h1>
                  
                  <div class="contact_p"> 
                      <h5 class="wonder_text">I'd love to hear from you🤙</h5>
                  </div>
                </div>

           <div class="row mt-4 p-0 ml-0 no-gutters">
            <div class="col-sm-12 col-xs-12 col-lg-6 col-md-12 contact" style="margin-bottom:0px;"  >

               <form  @submit.prevent="handleSubmit" name="contact"  method="POST" data-netlify-honeypot="bot-field" data-netlify="true" netlify>
   
      <div class="form-group">
        <div class="col-sm-12 ">
          <input type="text" v-model="form.name" class="form-control" id="name" placeholder="NAME" name="name" required>
         
        </div>
      </div>  
             



   <div class="form-group">
        <div class="col-sm-12">
          <input type="number" name="number" v-model="form.number" class="form-control" id="number" placeholder="NUMBER" required >
        </div>
      </div>          

 


      <div class="form-group">
        <div class="col-sm-12">
          <input type="email" v-model="form.email" name="email" class="form-control" id="email" placeholder="EMAIL" required>
          
        </div>
      </div>
      

      <div class="form-group">
        <div class="col-sm-12">
      <textarea class="form-control" v-model="form.message" rows="10" placeholder="MESSAGE" name="message" style="height:200px!important"></textarea>
        </div>
        </div>
       
      <div class="button row">
          <button type="submit"   class="btn-btn-dark m-auto send"  >Send</button>
      </div>
</form>

             



            </div>
         

          <div class="col-sm-12 col-xs-12 col-lg-6 col-md-12 contact " style="margin-bottom:0px;"  >


            <div class="direct-contact-container">

        <ul class="contact-list">
          <li class="list-item" style="color:#FF033E;font-size:25px"><i class="fa fa-map-marker "><span class="contact-text place"> 36 Danum Rd, Brampton</span></i></li>
          
          <li class="list-item"  style="color:#FF033E;font-size:25px"><i class="fa fa-phone" ><span class="contact-text phone"><a href="tel:1-226-961-1262" title="Give me a call">(226) 961-1262</a></span></i></li>
          
          <li class="list-item"  style="color:#FF033E;font-size:25px"><i class="fa fa-envelope"><span class="contact-text gmail"><a href="mailto:damanharneet@gmail.com" title="Send me an email">damanharneet@gmail.com</a></span></i></li>
          
        </ul>

        <hr>
        <ul class="social-media-list">
          <li><a href="https://github.com/Damanharneet" target="_blank" class="contact-icon">
            <i class="fa fa-github" aria-hidden="true"></i></a>
          </li>
         
          <li><a href="https://www.instagram.com/daman_kaurarora" target="_blank"  class="contact-icon">
            <i class="fa fa-instagram" aria-hidden="true"></i></a>
          </li>
          <li><a href="https://www.facebook.com/Harneet0779" target="_blank" class="contact-icon">
            <i class="fa fa-facebook" aria-hidden="true"></i></a>
          </li>
        </ul>
        <hr>

        
    
  </div>


            </div>






            </div>


      </div>
      </div>
      </div>

</template>
<script>
export default {
  data:()=>({
    form:{
      name:'',
      number:'',
      email:'',
      message:''
    }

  }),
  methods:{
    encode(data){
      return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
    },
    handleSubmit(){
      fetch('/',{
        method:'POST',
        headers:{
         
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body:this.encode({
          'form-name':'contact',
          ...this.form
        })
      })
      .then(()=>
      {console.log('succesfully sent')
      this.form={
      name:'',
      number:'',
      email:'',
      message:''
    }
      })
      .catch(e => console.error(e))

    }
  }
}
</script>
<style scoped>
.contain{
    margin-left:70px;
    margin-right:80px;
    
    margin-bottom:50px;
   
        box-sizing: border-box;
}
.contact_text{
   
    position:relative;
    color:white;
    margin-left:0px;
    font-family: 'Merriweather Sans', sans-serif;  
}
.contact_text:after{
    position:absolute;
    content:"";
    display:block;
    height:0.5px;
    width:calc(100% - 167px);
     top:60%;
      left:167px;
    background:#FF033E;
}
.contact_p{
    color:white;
    font-size:17px;
     font-family: 'Source Sans Pro', sans-serif;
      letter-spacing:0.5px;
      position:relative;
     text-align:justify;
     font-weight:500;
}
.wonder_text{
    color:#00CED1;
    font-size:16px;
    margin-top:-10px;
  font-family: 'Source Sans Pro', sans-serif;
    margin-left:0px;
     font-weight:600;
  letter-spacing:1px;
}
input, textarea{
    background-color:#002244;
    color:white;
    height:45px;
    border:none;
    border-radius:5px;
}
input::placeholder,textarea::placeholder{
    color:white;
}
.contact{
   
    margin-left:-15px;/*change*/
    font-size:17px;
    
    letter-spacing:0.6px;
    text-align:justify;
}
.contact-list {
  list-style-type: none;
  text-align:left;
  margin-left:90px;
}
.list-item {
  line-height: 3;
  color: white;
}
.contact-text, .contact-text a{
  font: 500 20px 'Source Sans Pro', sans-serif;
  letter-spacing: 1.4px;
  color: white;
    text-decoration: none;
  
}
.place {
  margin-left: 10px;
}

.phone {
  margin-left: 12px;
}

.gmail {
  margin-left: 12px;
}
.social-media-list {
  position: relative;
  font-size: 2.3rem;
  text-align: center;
  width: 100%;
  margin-left:0px;
}

.social-media-list li a {
  color: white;
}
.social-media-list li {
  position: relative; 
  top: 0;
  left: -20px;
  display: inline-block;
  height: 40px;
  width: 40px;
  margin: 10px 10px;
  line-height: 40px;
  border-radius: 0%;
  color: #fff;
 
  cursor: pointer; 
  transition: all .2s ease-in-out;
}
.social-media-list li:hover a {
  color:#FF033E;
}



hr {
  border-color: white ;
  width:60%;
  
}
.send{
    background-color:#2c3968;
    width:140px;
    height:40px;
    border:1px solid #FF033E;
    color:white;
    border-radius:5px;

}
@media screen and (max-width: 567px)  {
    .contain{
    margin-left:10px;
    margin-right:10px!important;
    
   
    
}
.contact-list {
 
  margin-left:-20px;
  font-size:16px;
  margin-top:30px;
}
.contact{
  width:200%;
}
hr {
  
  width:90%;
  
}
}
@media screen and (min-width:1400px){

.contain{
   margin-left:100px;
    margin-right:100px;
}
.contact-list {
 
  margin-left:120px;
}
}
@media screen and (min-width: 768px)and (max-width:1000px){
  .contain{
     margin-left:50px;
    margin-right:50px;
  }
  .contact-list {
 
  margin-left:150px;
  margin-top:40px;
}
}
@media screen and (min-width: 568px) and (max-width: 767px)  {
     .contain{
    margin-left:30px;
    margin-right:30px!important;
    
    margin-bottom:50px;
    
}
.contact-list {
 
  margin-left:90px;
  font-size:16px;
  margin-top:30px;
}
.contact{
  width:200%;
}
hr {
  
  width:70%;
  
}
}


</style>